var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAndroidLogo = function SvgIconAndroidLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.625 16.125a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M15.375 16.125a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.293 4.543a1 1 0 0 1 1.414 0L6.01 6.845A10.6 10.6 0 0 1 11.96 5a10.75 10.75 0 0 1 6.045 1.833l2.29-2.29a1 1 0 1 1 1.413 1.414L19.56 8.106l.028.028a10.75 10.75 0 0 1 3.163 7.616V18A1.75 1.75 0 0 1 21 19.75H3A1.75 1.75 0 0 1 1.25 18v-2.147c0-3.007 1.226-5.752 3.21-7.728L2.294 5.957a1 1 0 0 1 0-1.414m15.17 4.371q.015.014.032.026a8.76 8.76 0 0 1 3.255 6.81v2H3.25v-1.897a8.89 8.89 0 0 1 3.226-6.859q.07-.046.133-.108A8.63 8.63 0 0 1 11.966 7a8.75 8.75 0 0 1 5.496 1.914",
    clipRule: "evenodd"
  }))));
};
export default SvgIconAndroidLogo;